<template>
  <div :style="iconStyle" v-html="iconContent"></div>
</template>

<script>
export default {
  name: "cxTabsIcon",
  props: {
    iconStyle: {
      type: Object,
      required: true
    },
    iconSrc: {
      type: String,
      required: false
    }
  },
  data() {
    return {}
  },
  computed: {
    iconContent() {
      if (!this.iconSrc) {
        return ""
      }
      let svgContent = this.$store.state.states.iconSvg
      if (this.iconSrc && svgContent && svgContent.hasOwnProperty(this.iconSrc)) {
        return svgContent[this.iconSrc]
      }
      if (!svgContent || !svgContent.hasOwnProperty(`${this.iconSrc}`)) {
        this.$store.commit("states/updateSvg", {
          svgId: this.iconSrc,
          value: ""
        })
        this.getSvgContent(this.iconSrc)
      }
    }
  },
  components: {},
  mounted() {},
  methods: {
    getSvgContent(iconSrc) {
      this.$API
        .querySvg({
          publicId: iconSrc
        })
        .then(res => {
          if (res?.status !== 200) return
          this.$store.commit("states/updateSvg", {
            svgId: iconSrc,
            value: res.data
          })
        })
    }
  }
}
</script>

<style scoped>
::v-deep svg * {
  stroke: var(--color);
}
::v-deep svg {
  vertical-align: top;
  width: 100%;
  height: 100%;
}
</style>
